import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f0bdb32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-container" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  key: 0,
  class: "close-btn"
}

import ButtonClose from './ButtonClose.vue';
    

    interface IProps {
        showbtn: boolean
    }
    
export default /*#__PURE__*/_defineComponent({
  __name: 'ModalWindow',
  props: {
    showbtn: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

    


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (props.showbtn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(ButtonClose, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("x")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ])
  ]))
}
}

})